import messages from './messages'

/**
 * Interceptors
 */
export default (http, router) => {
  http.interceptors.response.use(
    response => messages.success(response),
    error => messages.error(error, router)
  )
}



// WEBPACK FOOTER //
// ./src/http/interceptors.js